<section
  [ngClass]="{
    'py-1' : removeMargin,
    'mb-3 py-4' : !removeMargin
  }"
  class="form-row">
  <div class="container-fluid">
    <div class="row mb-3">
      <div class="col-lg-4 col-sm-12" *ngIf="formRowTitle || description || warnings">
        <strong>{{ formRowTitle }}</strong>
        <p *ngIf="description"><em>{{ description }}</em></p>
        <field-warnings *ngIf="warnings" [warnings]="warnings"></field-warnings>
      </div>
      <div class="col-lg-8 col-sm-12" [class.offset-lg-4]="!formRowTitle && !description">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</section>
